import { addressToString } from '@debbie/common/dist/index.js'
import { useMutation } from '@debbie/common/dist/util/hooks.js'
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Container } from '@debbie/iris/dist/components/Grid/index.js'
import { ThumbsUp } from '@debbie/iris/dist/components/Icons/index.js'
import { Button, Input, Panel } from '@debbie/iris/dist/components/index.js'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import logo from '../assets/images/logoneg.svg'

const ExperianClientNumber = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const { creditorId } = useParams<{ creditorId: string }>()
  const [_experianClientId, setExperianClientId] = useState('')
  const [success, setSuccess] = useState(false)

  const {
    tenantName,
    creditorName,
    creditorCentralRegisterId,
    experianClientId,
    creditorAddress,
  } = JSON.parse(
    new URLSearchParams(window.location.search).get('data') || '{}',
  )

  const submitClientId = useMutation(
    async () => {
      if (
        [creditorCentralRegisterId, experianClientId].includes(
          _experianClientId,
        )
      ) {
        throw 'error'
      }
      await creditorsAPI.experianUpdate(creditorId, {
        experianClientId: _experianClientId,
      })
    },
    {
      onSuccess: () => {
        setSuccess(true)
      },
      onError: () => {
        if (
          [creditorCentralRegisterId, experianClientId].includes(
            _experianClientId,
          )
        ) {
          alert(
            'Klientnummeret kan ikke være identisk med CVR eller Experian kundenummer',
          )
        } else {
          alert('Der skete en fejl. Prøv venligst igen eller kontakt Debbie')
        }
      },
    },
  )

  return (
    <Container style={{ width: '700px' }}>
      <br />
      <img src={logo} className="logo" alt={lang.misc.logo} width="160px" />
      <Panel header={lang.experianClientNumber.header}>
        <h2>
          {tenantName} {lang.experianClientNumber.withAksCustomerNumber}{' '}
          <b>{experianClientId}</b> {lang.experianClientNumber.partnershipText}{' '}
          <i>{creditorName}</i>{' '}
          {lang.experianClientNumber.forFutureRegistrations}
        </h2>
        <h3>
          {lang.experianClientNumber.companyName} <i>{creditorName}</i>
        </h3>
        <p>
          CVR: <b>{creditorCentralRegisterId}</b>
        </p>
        {creditorAddress?.address && (
          <p>
            {lang.experianClientNumber.address}{' '}
            <b>{addressToString(creditorAddress)}</b>
          </p>
        )}
        {/* <h4>{tenantName}</h4>
        <h3>
          Indtast klientnummer for <i>{creditorName}</i>
        </h3>
        <p>
          CVR: <b>{creditorCentralRegisterId}</b>
        </p>
        {experianClientId && (
          <p>
            Experian kundenummer: <b>{experianClientId}</b>
          </p>
        )} */}
        {success ? (
          <div>
            <h1>
              <ThumbsUp /> {lang.experianClientNumber.clientNumberRegistered}
            </h1>
          </div>
        ) : (
          <div>
            <Input
              value={_experianClientId}
              onChange={(e) => {
                setExperianClientId(e.target.value)
              }}
              placeholder={lang.experianClientNumber.clientNumberPlaceholder}
              autofocus
            />
            <Button
              onClick={() => submitClientId.mutate()}
              loading={submitClientId.isLoading}
              disabled={
                !(
                  _experianClientId &&
                  _experianClientId.length > 2 &&
                  !isNaN(parseInt(_experianClientId))
                )
              }
            >
              {lang.experianClientNumber.submit}
            </Button>
          </div>
        )}
      </Panel>
    </Container>
  )
}

export default ExperianClientNumber
